const calculateScoreDifferences = (players) => {
  const playerArray = Array.from(players.values());
  return playerArray.map((player, i) => {
    if (i < playerArray.length - 1) {
      const diff = player.maxScore - playerArray[i + 1].maxScore;
      return diff > 0 ? `+${diff}` : diff.toString();
    }
    return null;
  }).filter(diff => diff !== null);
};

const truncateName = (name) => name.length > 12 ? `${name.substring(0, 12)}...` : name;

function getLastFourElementsWithData (data) {
  const playerMostThrows = Array.from(data).reduce(
    (prevPlayer, currentPlayer) =>
      currentPlayer[1].throws.length > prevPlayer.length
        ? currentPlayer[1].throws
        : prevPlayer,
    [],
  );

  const framesOrigin = Array.from(
    { length: Math.min(Math.ceil(playerMostThrows.length / 2), 10) },
    (_, index) => index,
  );

  const frames =
    framesOrigin.length < 5
      ? Array.from({ length: 4 }, (_, index) => index)
      : framesOrigin.slice(-4);

  return frames
}

export { calculateScoreDifferences, truncateName, getLastFourElementsWithData }